import { useFlagsmith } from 'flagsmith/react';
import { useMemo } from 'react';

export const useFlagDetails = () => {
  const flagsmith = useFlagsmith();
  const { getAllTraits } = flagsmith;
  const allTraits = getAllTraits();
  const allFlags = useMemo(() => flagsmith.getAllFlags() || {}, [flagsmith]);

  const enabledFlags = useMemo(() => {
    return Object.fromEntries(Object.entries(allFlags).filter(([_, value]) => value.enabled));
  }, [allFlags]);

  return {
    enabledFlags,
    allTraits
  };
};
